import React, { SVGAttributes } from 'react';
import classNames from 'classnames';
import { IconNames, Icons } from './Icons';
import styles from './Icon.module.scss';

export const Icon = ({
    type, className, size = 'medium',
    fill, stroke,
    ...attributes
}: IconProps) => {

    const classes = classNames(styles.icon, styles[size], className);

    return (
        <svg viewBox='0 0 24 24' className={classes} style={{ fill, stroke }}
            strokeLinecap='round' strokeLinejoin='round' stroke={stroke} fill={fill}
            {...attributes}>
            {Icons[type]}
        </svg>
    );
};

export type IconProps = SVGAttributes<SVGElement> & {
    type: IconNames;
    className?: string;
    size?: 'small' | 'medium' | 'large' | 'xlarge';
};